import { createQueryKeys } from 'query-keys';
import type { TaskId, TaskListParams, WorkOrderId, WorkOrderListParams } from '../workOrders';

export const workOrderQueryKeys = createQueryKeys('workOrders', {
  list: (params: WorkOrderListParams) => params,
  detail: (id: WorkOrderId) => ({ id }),
  task: (id: TaskId) => ({ id }),
  tasks: (params: TaskListParams) => params,
});
